import { normalizeType, type ExerciseType } from "./activity";

/** Line icons (24×24, stroke). Keys are stored in the catalog `icon` field. */
export const ICON_PATHS: Record<string, string> = {
  football:
    "M12 3a9 9 0 100 18 9 9 0 000-18zM12 8.2l3 2.2-1.1 3.5h-3.8L9 10.4zM12 3v5.2M15 10.4l5.4-1.8M13.9 13.9l3.2 4.2M10.1 13.9l-3.2 4.2M9 10.4L3.6 8.6",
  swim:
    "M2 19c2 0 2-1.4 4-1.4S8 19 10 19s2-1.4 4-1.4S16 19 18 19s2-1.4 4-1.4M15.5 5.5a1.8 1.8 0 100 3.6 1.8 1.8 0 000-3.6zM4 14.5l5.2-4.2 4 2.4 2.8-3.2",
  judo:
    "M8 3l4 4 4-4 3.5 3-2 4.5V21H6.5V10.5l-2-4.5zM12 7v14M6.5 14.5h11",
  yoga:
    "M12 4.2a1.8 1.8 0 100 3.6 1.8 1.8 0 000-3.6zM12 9v5M5 11.5l7 2.5 7-2.5M4 19c2-1.6 4.5-2.3 8-2.3s6 .7 8 2.3",
  run:
    "M14.5 3.5a1.8 1.8 0 100 3.6 1.8 1.8 0 000-3.6zM12 8.5l-3.2 3.8 3.4 2.2-1.4 5.5M12 8.5l4 2.7 3 .5M8.8 12.3L4.5 13M12.2 14.5l4.3 1.5 1 4",
  bike:
    "M6 11.5a4 4 0 100 8 4 4 0 000-8zM18 11.5a4 4 0 100 8 4 4 0 000-8zM6 15.5l4-7h5l3 7M10 8.5H8M12.5 8.5l-2.5 7",
  tennis:
    "M10 3.5a6 6 0 100 12 6 6 0 000-12zM14.4 14.4L20.5 20.5M6.5 7.3l7 4.4M5.7 10.7l5.6 3.4",
  basketball:
    "M12 3a9 9 0 100 18 9 9 0 000-18zM12 3v18M3 12h18M5.7 5.7c3 3 3 9.6 0 12.6M18.3 5.7c-3 3-3 9.6 0 12.6",
  hike: "M3 20l6-11 4 6 2-3 6 8zM9 9V4l4 1.5L9 7",
  ski: "M15.5 3.5a1.8 1.8 0 100 3.6 1.8 1.8 0 000-3.6zM13.5 8.5L9.5 12l3.8 3-1 4.5M17.5 8.5l-4 .8M4 20l16-3.5",
  boxing:
    "M7 7.5A4.5 4.5 0 0111.5 3h2A4.5 4.5 0 0118 7.5V12a4.5 4.5 0 01-4.5 4.5H9V21H7zM7 13.5h11",
  pulse: "M3 12h4l2.2-6 4.2 12 2.4-6H21",
  // type defaults
  strength: "M6.5 6.5v11M17.5 6.5v11M3.5 9v6M20.5 9v6M6.5 12h11",
  timed:
    "M12 6a7.5 7.5 0 100 15 7.5 7.5 0 000-15zM12 13.5V9.5M9.5 2.5h5M18.5 5l1.5-1.5",
  distance:
    "M6 15a2.5 2.5 0 100 5 2.5 2.5 0 000-5zM18 4a2.5 2.5 0 100 5 2.5 2.5 0 000-5zM8.5 17.5h6a3.5 3.5 0 000-7h-5a3.5 3.5 0 010-7H15.5",
  session:
    "M8.5 9.5a5 5 0 100 10 5 5 0 000-10zM8.5 14.5h.01M12.5 11l8.5-3v3.5l-6 .5M13 9.5V6",
};

/** Icons the user can pick for a custom activity (the type icons are not in this list). */
export const PICKABLE_ICONS = [
  "football",
  "swim",
  "judo",
  "yoga",
  "run",
  "bike",
  "tennis",
  "basketball",
  "hike",
  "ski",
  "boxing",
  "pulse",
] as const;

/** Icon of a type, used when an exercise has no icon of its own. */
export function typeIconKey(type: ExerciseType | undefined): string {
  return normalizeType(type);
}
